import Vue from 'vue';

const DEFAULT_TITLE = 'Predição de Evasão - SESI/SENAI';

const afterEach = (to, from) => {

  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    if (to.meta.title) {
      document.title = DEFAULT_TITLE + ' - ' + to.meta.title;
    } else {
      document.title = DEFAULT_TITLE;
    }
  });
}

export default afterEach;



// WEBPACK FOOTER //
// ./src/router/afterEach.js